import { Rule } from "../types/Campaigns";

export function describeCampaignRule(rule: Rule): string {
  let description = `When ${rule.metric} ${rule.comparator} ${rule.targetValue}`;

    var comparatorDescription = "";
    switch (rule.comparator) {
        case ">":
            comparatorDescription = "more than";
            break;
        case ">=":
            comparatorDescription = "at least";
            break;
            case "==":
            comparatorDescription = "exactly";
            break;
    }

  if (rule.type === "duration") {
    return `Any single stream is ${comparatorDescription} ${rule.targetValue} minutes long`;
  }

  if (rule.type === "all_streams_duration") {
    return `Total duration across all streams is ${comparatorDescription} ${rule.targetValue} minutes`;
  }

  if (rule.type === "unique_days") {
    return `User streams on ${comparatorDescription} ${rule.targetValue} unique days`;
  }

  if (rule.type === "streak") {
    return `User streams for ${comparatorDescription} ${rule.targetValue} days in a row`;
  }

  if (rule.type === "total_streams") {
    return `User has ${comparatorDescription} ${rule.targetValue} total streams`;
  }

  return description;
}
